<!--
 * @Author: tony.zhu
 * @Date: 2025-10-16 14:15:49
 * @LastEditTime: 2025-10-16 14:28:22
 * @LastEditors: tony.zhu
 * @Description: 
-->

<template>
  <div class="c-loading">
    <template v-if="loadingType == 'default'">
      <div class="loading_box_wrap">
        <div class="title">正在思考</div>
        <div class="loading_wrap">
          <span class="loading_wrap__item"></span>
          <span class="loading_wrap__item"></span>
          <span class="loading_wrap__item"></span>
          <span class="loading_wrap__item"></span>
        </div>
      </div>
    </template>
    <template v-if="loadingType == 'image'">
      <div class="image_loading_wrap">
        <div class="content_wrap">
          <span class="content_wrap__item"></span>
          <span class="content_wrap__item"></span>
          <span class="content_wrap__item"></span>
          <span class="content_wrap__item"></span>
          <span class="content_wrap__item"></span>
          <span class="content_wrap__item"></span>
          <span class="content_wrap__item"></span>
          <span class="content_wrap__item"></span>
          <span class="content_wrap__item"></span>
          <span class="content_wrap__item"></span>
          <span class="content_wrap__item"></span>
          <span class="content_wrap__item"></span>
          <span class="content_wrap__item"></span>
        </div>
        <span class="text">正在生成图片</span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    loadingType: {
      String: String,
      default: 'default'
    }
  }
}
</script>

<style lang="scss" scoped>
.c-loading {
  .loading_box_wrap {
    display: flex;
    align-items: center;
    background: #ffffff;
    border-radius: 0px 8px 8px 8px;
    padding: 12px 0 12px 12px;
    .title {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      line-height: 20px;
      color: #1d2129;
    }
  }
  .loading_wrap {
    display: flex;
    align-items: center;
    padding: 0 12px;
    height: 4px;
    margin: 9px 0;
    &__item {
      width: 4px;
      height: 4px;
      margin-right: 4px;
      border-radius: 50%;
      background: rgba(78, 89, 105, 1);
      &:nth-last-of-type(1) {
      }
      &:nth-last-of-type(2) {
        animation-delay: -1s;
      }
      &:nth-last-of-type(3) {
        animation-delay: -1.4s;
      }
      &:nth-last-of-type(4) {
        animation-delay: -2.7s;
      }
      &:last-child {
        margin-right: 0;
      }
      animation: animations 3s ease infinite alternate;
    }
  }

  @keyframes animations {
    10% {
      opacity: 0.7;
    }

    30% {
      opacity: 1;
    }

    60% {
      opacity: 0.6;
    }

    100% {
      opacity: 0.3;
    }
  }

  .image_loading_wrap {
    display: flex;
    align-items: center;
    .text {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      line-height: 20px;
      font-size: 14px;
      color: #1d2129;
      line-height: 22px;
      margin-left: 4px;
    }

    .content_wrap {
      position: relative;
      width: 24px;
      height: 24px;
      display: flex;
      align-items: center;

      &__item {
        position: absolute;
        width: 1px;
        height: 4px;
        left: 50%;
        background: rgba(118, 87, 251, 1);

        &:nth-child(1) {
          transform: rotate(0deg) translate(-50%, 8px);
          animation-delay: 0s;
          opacity: 0.6;
        }
        &:nth-child(2) {
          transform: rotate(30deg) translate(-50%, 8px);
          animation-delay: 0.1s;
          opacity: 0.5;
        }
        &:nth-child(3) {
          transform: rotate(60deg) translate(-50%, 8px);
          animation-delay: 0.2s;
          opacity: 0.4;
        }
        &:nth-child(4) {
          transform: rotate(90deg) translate(-50%, 8px);
          animation-delay: 0.3s;
          opacity: 0.3;
        }
        &:nth-child(5) {
          transform: rotate(120deg) translate(-50%, 8px);
          animation-delay: 0.4s;
          opacity: 0.2;
        }
        &:nth-child(6) {
          transform: rotate(150deg) translate(-50%, 8px);
          animation-delay: 0.5s;
          opacity: 0.1;
        }
        &:nth-child(7) {
          transform: rotate(180deg) translate(-50%, 8px);
          animation-delay: 0.6s;
          opacity: 1;
        }
        &:nth-child(8) {
          transform: rotate(210deg) translate(-50%, 8px);
          animation-delay: 0.7s;
          opacity: 0.98;
        }
        &:nth-child(9) {
          transform: rotate(240deg) translate(-50%, 8px);
          animation-delay: 0.8s;
          opacity: 0.95;
        }
        &:nth-child(10) {
          transform: rotate(270deg) translate(-50%, 8px);
          animation-delay: 0.9s;
          opacity: 0.9;
        }
        &:nth-child(11) {
          transform: rotate(300deg) translate(-50%, 8px);
          animation-delay: 1s;
          opacity: 0.8;
        }
        &:nth-child(12) {
          transform: rotate(330deg) translate(-50%, 8px);
          animation-delay: 1.1s;
          opacity: 0.7;
        }
        &:nth-child(13) {
          transform: rotate(360deg) translate(-50%, 8px);
          animation-delay: 1.2s;
          opacity: 0.6;
        }
        animation: rotate 1.2s linear infinite;
      }
    }

    @keyframes rotate {
      from {
        opacity: 1;
      }
      to {
        opacity: 0.25;
      }
    }
  }
}
</style>
